import { HttpErrorResponse } from '@angular/common/http';

export type ResponseStatus = 'success' | 'error' | 'inProgress';

interface BaseResponse {
  status: ResponseStatus;
}

interface Success<T> extends BaseResponse {
  status: 'success';
  data?: T;
}

interface Error extends BaseResponse {
  status: 'error';
  error: HttpErrorResponse;
}

interface InProgress extends BaseResponse {
  status: 'inProgress';
}

export type Response<T> = Success<T> | Error | InProgress;
